class ProductStickyNav extends HTMLElement {
  constructor() {
    super();
    this.headerOffset = parseInt(this.dataset.offset || '0', 10);
    this.originalLinks = this.querySelectorAll('.product-sticky-nav-link');
    
    // We create a clone of this entire navigation bar and attach it directly to the <body>.
    // This perfectly bypasses ANY theme animations, overflows, or translation bugs.
    this.fixedWrapper = document.createElement('div');
    this.fixedWrapper.className = this.className; // inherits 'product-sticky-nav'
    this.fixedWrapper.innerHTML = this.innerHTML;
    
    // Set clone's fixed styles
    Object.assign(this.fixedWrapper.style, {
      position: 'fixed',
      left: '0',
      right: '0',
      top: '-999px', // hidden initially
      width: '100%',
      zIndex: '2147483647',
      margin: '0',
      visibility: 'hidden',
      boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
    });
    
    document.body.appendChild(this.fixedWrapper);
    this.fixedLinks = this.fixedWrapper.querySelectorAll('.product-sticky-nav-link');

    this.onScroll = this.onScroll.bind(this);
    this.getDynamicHeaderHeight = this.getDynamicHeaderHeight.bind(this);
    this.isFixed = false;
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    
    // Initialize
    setTimeout(() => {
      this.onScroll();
    }, 100);

    // Smooth scroll for both Original and Cloned Links
    const allLinks = [...this.originalLinks, ...this.fixedLinks];
    allLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('data-target');
        const targetEl = document.querySelector(targetId);
        
        if (targetEl) {
          const headerH = this.getDynamicHeaderHeight();
          const navH = this.fixedWrapper.offsetHeight || this.offsetHeight || 60; 
          const targetPosition = targetEl.getBoundingClientRect().top + window.scrollY - headerH - navH + 2;
          
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (this.fixedWrapper && this.fixedWrapper.parentNode) {
      this.fixedWrapper.parentNode.removeChild(this.fixedWrapper);
    }
  }

  getDynamicHeaderHeight() {
    let lowestBottom = 0;
    const headerSelectors = ['#shopify-section-header', '#SiteHeader', '.site-header', '.header-wrapper', 'header', '.header', '#header'];
    
    for (const selector of headerSelectors) {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        // Check if header is sticky (stays near top of viewport)
        if (rect.height > 0 && rect.bottom > 0 && rect.top <= 10 && rect.bottom < (window.innerHeight / 2)) {
          if (rect.bottom > lowestBottom) {
            lowestBottom = rect.bottom;
          }
        }
      });
    }
    return lowestBottom;
  }

  onScroll() {
    const headerH = this.getDynamicHeaderHeight();
    const triggerOffset = headerH + this.headerOffset;
    
    // The original element ALWAYS safely stays in the normal document flow.
    // We just check if its top edge has scrolled beyond our header offset.
    const rect = this.getBoundingClientRect();
    
    if (rect.top <= triggerOffset) {
      if (!this.isFixed) {
        this.isFixed = true;
        this.fixedWrapper.style.visibility = 'visible';
        this.fixedWrapper.style.pointerEvents = 'auto'; // allow clicks
        
        // Make the original invisible so we don't see double, but keep its physical space!
        this.style.visibility = 'hidden';
        this.style.pointerEvents = 'none'; 
      }
      this.fixedWrapper.style.top = triggerOffset + 'px';
    } else {
      if (this.isFixed) {
        this.isFixed = false;
        this.fixedWrapper.style.visibility = 'hidden';
        this.fixedWrapper.style.pointerEvents = 'none';
        this.fixedWrapper.style.top = '-999px';
        
        // Restore original!
        this.style.visibility = 'visible';
        this.style.pointerEvents = 'auto';
      }
    }

    // Scroll Spy Logic
    let currentSectionId = '';
    const scrollY = window.scrollY;
    const scrollPosition = scrollY + headerH + this.headerOffset + (this.offsetHeight || 60) + 20; 
    
    this.originalLinks.forEach(link => {
      const targetId = link.getAttribute('data-target');
      const targetEl = document.querySelector(targetId);
      if (targetEl) {
        const sectionTop = targetEl.getBoundingClientRect().top + window.scrollY;
        const sectionHeight = targetEl.offsetHeight;
        if (scrollPosition >= sectionTop && scrollPosition < (sectionTop + sectionHeight)) {
          currentSectionId = targetId;
        }
      }
    });

    [this.originalLinks, this.fixedLinks].forEach(linkGroup => {
        linkGroup.forEach((link) => {
          link.classList.remove('is-active');
          if (currentSectionId && link.getAttribute('data-target') === currentSectionId) {
            link.classList.add('is-active');
          }
        });
    });
  }
}

if (!customElements.get('product-sticky-nav')) {
  customElements.define('product-sticky-nav', ProductStickyNav);
}
